'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionFee', ['$scope', '$stateParams', 'IPExtraFees', '$state', function ($scope, $stateParams, IPExtraFees, $state) {
        $scope.resetInspection();
        $scope.inspection_fee = {};
        $scope.inspection_fee.ipInspectionId = $scope.inspectionID;
        $scope.inspectionFeeID = $stateParams.inspectionFeeID;
        $scope.saving = false;
        $scope.deleting = false;

        if ($scope.inspectionFeeID != null) {
            $scope.loading = true;
            IPExtraFees.getByID($scope.inspectionFeeID).then(function (fee) {
                $scope.inspection_fee = fee;
                $scope.loading = false;
            })
        }

        $scope.save = function () {
            $scope.saving = true;
            if ($scope.inspection_fee.id == null) {
                if ($scope.inspection_fee.value != null) { $scope.inspection_fee.value = parseInt($scope.inspection_fee.value) }
                IPExtraFees.createFee($scope.inspection_fee).then(function (fee) {
                    updateArray($scope.inspection.ip_extra_fees, fee);
                    updateArray($scope.masterInspection.ip_extra_fees, fee);
                    $state.go('internal.inspecting.inspection.outcome', { id: $scope.inspectionID });
                    $scope.saving = false;
                });
            }
            else {
                if ($scope.inspection_fee.value != null) { $scope.inspection_fee.value = parseInt($scope.inspection_fee.value) }
                IPExtraFees.updateFee($scope.inspection_fee).then(function (fee) {
                    updateArray($scope.inspection.ip_extra_fees, fee);
                    updateArray($scope.masterInspection.ip_extra_fees, fee);
                    $state.go('internal.inspecting.inspection.outcome', { id: $scope.inspectionID });
                    $scope.saving = false;
                });
            }
        }

        $scope.delete = function () {
            $scope.deleting = true;
            IPExtraFees.deleteFee($stateParams.inspectionFeeID).then(function () {
                updateArray($scope.inspection.ip_extra_fees, $scope.inspection_fee, true);
                updateArray($scope.masterInspection.ip_extra_fees, $scope.inspection_fee, true);
                $state.go('internal.inspecting.inspection.outcome', { id: $scope.inspectionID });
                $scope.deleting = false;
            });
        }
    }])
;